import { useCallback, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table';
import type { PaginationState, ColumnFiltersState, SortingState } from '@tanstack/react-table';
import { handleSearchData, paginationQuery } from '../../../../utils/GlobalHelper'
import { MRT_Localization_AL, PAGES } from '../../../../constants/Constants'
import { useForm } from 'react-hook-form'
import { ServiceManagementDeleteAction, ServiceManagementListAction, ServiceManagementStatusAction } from '../../../../redux/Action/DashboardAction';
import ServiceManagementFilter from '../../../../components/Model/ServiceManagementFilter';
import { dateFormat, encodeID, handleShowSwalConfirmation, sidebarOpen } from '../../../../utils/Helper';
import { CategoryAction, ProfileGetCategoryAction } from '../../../../redux/Action/ProfileAction';
import _ from 'lodash';
import Button from '../../../../components/Ui/Button';
import { Config } from '../../../../config/Config';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';



const ServicesManagementTable = () => {


    const intl = useIntl();

    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const ServicesManagementList = useSelector((state: any) => state.ServiceManagementListState);
    const serviceManagementDelete = useSelector((state: any) => state.ServiceManagementDeleteState);
    const serviceManagementStatus = useSelector((state: any) => state.ServiceManagementStatusState);

    const [data, setData] = useState<any>();
    const [pagination, setPagination] = useState<PaginationState>({ pageIndex: PAGES?.pageIndex, pageSize: PAGES?.pageSize });
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [sorting, setSorting] = useState<SortingState>([]);
    const [rowCount, setRowCount] = useState(0);
    const [searchValue, setSearchValue]: any = useState('');
    const [isError, setIsError] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disableDate, setDisableDate] = useState(true)

    const role_id = Config?.USER_DETAILS?.role_id

    useEffect(() => {
        const fetchData = async () => {
            if (!data?.length) {
                setLoading(true);
            }
            else {
                setIsRefetching(true);
            }
            try {
                let query: any = paginationQuery(pagination.pageIndex, pagination.pageSize, sorting, searchValue, columnFilters);
                await dispatch(ServiceManagementListAction({ ...query, role_id: Config?.USER_DETAILS?.role_id }));
            }
            catch (error) {
                setIsError(true);
                return;
            }
            setIsError(false);
            setLoading(false);
            setIsRefetching(false);
        };
        if (columnFilters || pagination.pageIndex || pagination.pageSize || sorting || serviceManagementDelete || serviceManagementStatus) {
            fetchData();

        }
    }, [columnFilters, pagination.pageIndex, pagination.pageSize, sorting, serviceManagementDelete, serviceManagementStatus]);


    useEffect(() => {
        if (ServicesManagementList?.status) {
            setRowCount(ServicesManagementList?.data?.data?.count);
            setData(ServicesManagementList?.data?.data?.rows);
        }
    }, [ServicesManagementList?.data]);


    const handleStatus: any = (id: any, status: any) => {
        dispatch(ServiceManagementStatusAction({ status_id: id, status: status }))
    }



    const columns: any = [
        {
            accessorKey: 'S.NO',
            header: <FormattedMessage id="sno" />,
            accessorFn: (row: Object, index: number) => {
                return index + 1;
            },
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 80,
        },
        {
            accessorKey: 'name',
            header: <FormattedMessage id="service_name" />,
            enableSorting: false,
            accessorFn: (row: any) => {
                return row.name;
            },
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 150,

        },
        {
            accessorKey: 'duration',
            header: <FormattedMessage id="service_duration" />,
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 150,
        },
        {
            accessorKey: 'price',
            header: <FormattedMessage id="service_price" />,
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 150,
        },
        {
            accessorKey: 'category',
            header: <FormattedMessage id="category" />,
            enableSorting: false,
            accessorFn: (row: any) => {
                return row?.category_details?.name ? row?.category_details?.name : "N/A";
            },
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 150,
        },
        {
            accessorKey: 'created_at',
            // header:'creation_date' ,
            header: <FormattedMessage id="creation_date" />,
            accessorFn: (row: any) => { 
                return (
                    <>
                        <td>{dateFormat(row?.created_at)}</td>
                    </>
                )
            },
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 150,

        },
        {
            accessorKey: 'status',
            header: <FormattedMessage id="status" />,
            size: 90,
            accessorFn: (row: { id: any, status: number }) => <>
                <div className="form-check form-switch" >
                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                        checked={row.status == 1 ? true : false}
                        onClick={() => handleStatus(row?.id, row?.status == 1 ? 0 : 1)}
                    />
                </div>
            </>,
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
        },
        {
            header: <FormattedMessage id="action" />,
            size: 150,
            accessorFn: (row: { id: any, status: number }) => <>
                {/* <td> */}
                <div className='userAction'>
                    {
                        Config?.USER_DETAILS?.role_id == 1 && <>
                            <Link to={`/service-update/${encodeID(row?.id)}`} className='btn btnroundIcon'><i className="icon-edit"></i></Link>
                            <button type='button' className='btn btnroundIcon mx-1 mx-sm-2' onClick={() => handleDelete(row?.id)}><i className="icon-delete"></i></button>
                        </>
                    }
                    <Link to={`/service-management/view/${encodeID(row?.id)}`} className='btn btnroundIcon'><i className="icon-view"></i></Link>
                </div>
            </>,
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false
        },
    ]

    const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm({
        defaultValues: {
            start_date: "", end_date: "", searchValue: "", category: ""
        }
    }) as any;


    const [searched, setSearched] = useState<string>("");


    const onSubmit = (payload: any) => {

        const columnFilters = [
            { id: "start_date", value: payload?.start_date },
            { id: "end_date", value: payload?.end_date },
            { id: "category_id", value: payload?.category },
        ]
        setColumnFilters(columnFilters)
    }




    const handleReset = () => {
        reset();
        setSearched("")
        setColumnFilters([])
    }



    const requestSearch = useCallback(
        _.debounce((searchedVal: string) => {
            if (searchedVal.length > 0) {
                setSearched(searchedVal);

                const filteredRows = data && data.filter((row: any) => {
                    return row?.name?.toLowerCase().includes(searchedVal.toLowerCase());
                });
                const columnFilters = [
                    { id: "start_date", value: "" },
                    { id: "end_date", value: "" },
                    { id: "search", value: searchedVal },
                ]

                const dataData = [{ id: "search", value: searchedVal }]
                setColumnFilters(dataData)

            } else {
                setColumnFilters([])
            }
        }, 1000), // 300 milliseconds debounce time
        []
    );

    const handleSearchChange = (searchVal: any) => {
        const value = searchVal?.target?.value.replace(/\s{2,}/g, ' ');

        setSearched(value)
        requestSearch(value.trim());
    };

    // const handleSearchChange = (searchVal: any) => {
    //     setSearched(searchVal?.target?.value)
    //     requestSearch(searchVal?.target?.value);
    // };


    const handleFilter = () => {
        dispatch(ProfileGetCategoryAction({}));
    }



    const handleDelete = async (id: any) => {
        // let confirmation = await handleShowSwalConfirmation(<FormattedMessage id="delete_popup" />, true);
        let confirmation = await handleShowSwalConfirmation(intl.formatMessage({ id: 'delete_pop_up' }), true, true, intl.formatMessage({ id: 'are_you_sure' }));
    
        if (confirmation) {
            dispatch(ServiceManagementDeleteAction({ delete_id: id }))
        }
    }


    useEffect(() => {
        return () => {
            dispatch(ServiceManagementDeleteAction("RESET"))
            dispatch(ServiceManagementStatusAction("RESET"))
            dispatch(ServiceManagementListAction("RESET"))

        }
    }, []) // Reset data


    return (
        <>
            <div className='col-lg-9 serviceManagement'>
                <div className='dashboard bg-white'>
                    <div className='dashboardTop d-sm-flex align-items-center'>
                        <h2><button type='button' onClick={() => { sidebarOpen() }} className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button> {<FormattedMessage id="service_management" />}</h2>
                        <div className='filterBTN d-none d-sm-flex'>
                            <div className='search'>
                                <span className="icon-search"></span>
                                <input type='search' className='form-control' placeholder={intl.formatMessage({ id: 'search' })} value={searched} onChange={handleSearchChange} />
                            </div>

                            <button type='button' className='btn btn-fill filterlist btn-sm' data-bs-toggle="modal" data-bs-target="#servicelistFilter" onClick={handleFilter}><i className="icon-filter"></i> <FormattedMessage id="filter" /></button>
                            {role_id != 2 && <Button type="button" text={"+" + (intl.formatMessage({ id: 'add_new_service' }))} className='btn btn-sm-outline' onClick={() => navigate("/service")} />}
                            <button type='button' className='btn btn-sm-outline' onClick={handleReset}><FormattedMessage id="reset" /></button>
                        </div>

                        <div className='filterBTN d-sm-none'>
                            <div className='row gy-2'>
                                <div className='col-md-12'>
                                    <div className='search'>
                                        <span className="icon-search"></span>
                                        <input type='search' className='form-control  w-100' placeholder='Search' />
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <button type='button' className='btn btn-fill filterlist btn-sm w-100' data-bs-toggle="modal" data-bs-target="#servicelistFilter"><i className="icon-filter"></i> Filter</button>
                                </div>
                                <div className='col-6'>
                                {role_id != 2 && <Button type="button" text={"+" + (intl.formatMessage({ id: 'add_new_service' }))} className='btn btn-sm-outline' onClick={() => navigate("/service")} />}

                                    {/* <button type='button' className='btn btn-sm-outline  w-100'>+{<FormattedMessage id="add_new_service" />}</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='dashboarcard p-0'>
                        {

                            <MaterialReactTable
                                columns={columns}
                                data={data || []}
                                enableGlobalFilter={false}
                                enableHiding={false}
                                enableColumnFilters={false}
                                enableDensityToggle={false}
                                enableColumnActions={false}
                                enableFullScreenToggle={false}
                                positionToolbarAlertBanner="top"
                                localization={MRT_Localization_AL}

                                initialState={{
                                    showColumnFilters: true,
                                    globalFilter: searchValue // Set the default search value here
                                }}
                                manualFiltering
                                manualPagination
                                manualSorting

                                muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
                                muiSearchTextFieldProps={{
                                    placeholder: 'Search from name',
                                }}
                                onColumnFiltersChange={setColumnFilters}
                                onGlobalFilterChange={(value: any) => handleSearchData(
                                    value,
                                    setIsError,
                                    setLoading,
                                    setIsRefetching,
                                    setSearchValue,
                                )
                                }
                                onPaginationChange={setPagination}
                                onSortingChange={setSorting}
                                rowCount={rowCount}
                                state={{
                                    columnFilters,
                                    isLoading: loading,
                                    pagination,
                                    showAlertBanner: isError,
                                    showProgressBars: isRefetching,
                                    sorting,
                                }}
                            />
                        }
                    </div>
                </div>

            </div>
            <ServiceManagementFilter
                register={register}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                handleReset={handleReset}
                setValue={setValue}
                watch={watch}
                errors={errors}
                setDisableDate={setDisableDate}
                disableDate={disableDate}
            />
        </>

    )
}

export default ServicesManagementTable

